import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/dashboard/chef/demandes")({
  beforeLoad: () => {
    throw redirect({
      to: "/dashboard/chef/reservations",
      search: { tab: "a-traiter" },
    });
  },
});
